var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "width",
    height: "height",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2 0A5 5 0 1 1 7 7a5 5 0 0 1 10 0m-9 9c-1.491 0-2.729 1.991-2.96 4h13.92c-.231-2.009-1.469-4-2.96-4zm-5 4.667C3 21.403 3.448 22 4 22h16c.552 0 1-.597 1-1.333C21 16.985 18.761 14 16 14H8c-2.761 0-5 2.985-5 6.667",
    clipRule: "evenodd"
  })));
};
export default SvgPerson;